import { Svg } from "@client/components/Svg";
import React from "react";
import {
    Button,
    Label,
    ListBox,
    ListBoxItem,
    ListBoxItemProps,
    Popover,
    Select,
    SelectProps,
    SelectValue,
    Text,
    composeRenderProps,
} from "react-aria-components";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { CommonFieldProps, FieldError } from "./utils";

import styles from "./inputs.module.scss";

export function SelectField({
    label,
    description,
    errorMessage,
    children,
    className,
    storybook,
    ...props
}: CommonFieldProps &
    SelectProps<object> & {
        /**
         * we want to be able to pin a dropdown open for storybook, but this is
         * BAD JUJU for accessability. If you're using this outside storybook,
         * you're doing it very wrong
         */
        storybook?: boolean;
    }) {
    return (
        <Select
            className={concatClassNames([
                typeof className === "string" ? className : undefined, //React-Aria does some fancy function stuff I'm ignoring for now
                styles.dropdown,
            ])}
            placeholder="Please Select" // default
            {...props}
        >
            {composeRenderProps(children, (children) => (
                <>
                    <Label>{label}</Label>
                    <div>
                        <Button className={styles.dropdownTrigger}>
                            <SelectValue />
                            <Svg aria-hidden name="chevron" />
                        </Button>
                    </div>
                    {description && (
                        <Text slot="description">{description}</Text>
                    )}
                    <FieldError>{errorMessage}</FieldError>
                    <Popover
                        placement="bottom"
                        className={styles.dropdownPopover}
                        isNonModal={storybook || undefined}
                        offset={0}
                        shouldFlip={!storybook || undefined}
                    >
                        <ListBox>{children}</ListBox>
                    </Popover>
                </>
            ))}
        </Select>
    );
}

export function SelectOption({ children, ...props }: ListBoxItemProps) {
    return (
        <ListBoxItem
            textValue={typeof children == "string" ? children : undefined}
            {...props}
        >
            {composeRenderProps(children, (children) => (
                <span>{children}</span>
            ))}
        </ListBoxItem>
    );
}
